import Card from 'react-bootstrap/Card';
import { Placeholder } from 'react-bootstrap'; 
import placeholderImage from "../assets/Placeholder.png"

const RoomCard = () => {

  return (
    <Card 
      className="bg-white shadow-sm md mt-4" 
      style={{ width: '20rem', cursor: 'pointer' }}
    >
      <Card.Img variant="top" src={placeholderImage} style={{height: '14rem', borderRadius: '5px'}} alt="RoomCardHorizontalCarouselImage"/>

      <Card.Body>
        <Placeholder as={Card.Title} animation="glow">
          <Placeholder xs={6} />
        </Placeholder>

        <Placeholder as={Card.Text} animation="glow">
          <Placeholder xs={10} />
          <Placeholder xs={10} />
        </Placeholder>

        <hr style={{width: '90%', marginLeft: '1.2rem', marginTop: '2rem'}}/>

        <Placeholder as={Card.Text} animation="glow">
          <Placeholder xs={10} />
          <Placeholder xs={10} />
        </Placeholder>
      </Card.Body>
    </Card>
  )
}

export default RoomCard